<template>
    <div>   
        <div class="text-right">     
            <button class="button" @click="collapseAllClick()">
                <i class="pr-1" :class="collapseAll.icon"></i>  
                <span>{{collapseAll.label}}</span>    
            </button>   
        </div>      
        <node 
            :data="data"
            :nameFieldLabel="nameFieldLabel"
            :nameFieldChildrens="nameFieldChildrens"
            :showLineOnLeaf="showLineOnLeaf"        
            @nodeClick="nodeClick"
            @nodeRightClick="nodeRightClick"              
        >
        </node>                                                   
    </div>
</template>

<script>


import Node from './Node';

export default {
    name: "tree-view",

    components: {
        Node
    },

    props: {
        data: { type: Array, default: () => [] },
        nameFieldLabel:  { type: String, default: () => 'label' },
        nameFieldChildrens:  { type: String, default: () => 'childrens' }, 
        showLineOnLeaf:  { type: Boolean, default: () => true },
    },

    data() {
        return { 
            collapseAll:{
                value: true,
                icon: 'fa fa-plus-square-o',
                label: 'EXPANDIR TUDO'
            }      
        }
    },

    methods: {        
        nodeClick(item, event){
            this.$emit('nodeClick', item, event);
        }, 
        
        nodeRightClick(item, event){
            this.$emit('nodeRightClick', item, event);
        },
        
        collapseAllClick(){
            if(this.collapseAll.value){
               this.collapseAll.icon = 'fa fa-minus-square-o';
               this.collapseAll.label = 'RECOLHER TUDO';
            }else{
               this.collapseAll.icon = 'fa fa-plus-square-o';
               this.collapseAll.label = 'EXPANDIR TUDO';
            }    
          
            this.setShowDetailsRecursive(this.data, this.collapseAll.value);

            this.collapseAll.value = !this.collapseAll.value;
        },

        setShowDetailsRecursive(itens, value){
            itens.forEach(item => {                                  
                this.$set(item, '_showDetails', value); 

                if(item[`${this.nameFieldChildrens}`]){
                  this.setShowDetailsRecursive(item[`${this.nameFieldChildrens}`], value);  
                }                  
            });
        },
    },
    
    mounted(){       
        this.data.forEach(item => {                   
            this.$set(item, 'nodeRoot', true)                
        });
    }
}
</script>

<style scoped>
    .button{        
        background-color: transparent;
        color:#5F6368;
        border-style: none;          
        outline: none;
        font-size: 0.72rem;  
        font-weight: bold;           
    }

</style>
